export function calculateFee(feePercentage?: number) {
    return `${feePercentage ? Math.round((1 - Number(feePercentage ?? 0.0)) * 100) : 0}%`;
}
